import { createEvent } from '../../shared/utils/tracking.utils';

export const onboardingPopupShowEvent = createEvent('Onboarding Popup Shown');

export const onboardingPopupDismissedEvent = createEvent('Onboarding Popup Dismissed');

export const onboardingPopupNextEvent = createEvent('Onboarding Popup Next');

export const onboardingPopupPrevEvent = createEvent('Onboarding Popup Prev');

export const sidebarClicked = createEvent<{
  item: string;
}>('Sidebar clicked');

export const locationPicked = createEvent<{
  location: string;
}>('Location picked');

export const accountClicked = createEvent('Account clicked');

export const settingsClicked = createEvent('Settings clicked');

export const feedbackDismissed = createEvent<{
  method: 'explicit' | 'timeout';
}>('Feedback dismissed');
export const feedbackGiven = createEvent<{
  score: number;
}>('Feedback given');
export const feedbackDisplayed = createEvent('Feedback popup displayed');
